import vars from 'assets/utils/vars';

// eslint-disable-next-line
__webpack_public_path__ = vars.STATIC_URL;
